export const OPTION_CONSTANT={
    ADD:'ADD',
    CLEAR:'CLEAR',
    FILTER:'FILTER',
    OPTIONS:'OPTIONS',
    SEARCH_CHECHA:"SEARCH_CHECHA"
}